import React from 'react';
import ReactDOM from "react-dom/client";
import App, {route, group} from 'library/App';
import ServiceWorker from 'library/ServiceWorker';

// Platform home
route('/@platform/views/Home/HomeView.js');

// Identify
route('/identification/verify.html@platform/views/Identify/IdentifyView.js');

// Checkout
route('/documents/:documents_uuid/checkout.html@platform/views/Checkout/CheckoutView.js', 'orders@get_checkout_info');

// Summary
route('/documents/:documents_uuid/summary.html@platform/views/Summary/SummaryView.js');

// Share
route('/documents/:documents_uuid/share.html@platform/views/Share/ShareView.js', 'documents@get_document');

// Add admin for organization
route('/onboarding/:organizations_uuid/admin.html@platform/views/AddAdmin/AddAdminView.js', 'organizations@get_organization');

// ORGANIZATIONS

// Login as organization
route('/organizations/:organizations_uuid/login.html@organizations/views/Login/LoginView.js');

group(['ORGANIZATION_USER', 'ORGANIZATION_ADMIN'], () => {

    // Documents
    route('/organizations/documents.html@organizations/views/Documents/DocumentsView.js', 'documents@get_documents');

    // Profile
    route('/organizations/profile.html@organizations/views/Profile/ProfileView.js', 'profiles@get_profile');
});

group('ORGANIZATION_ADMIN', () => {

    // Users
    route('/organizations/users.html@organizations/views/Users/UsersView.js', 'users@get_users');

    // Billing
    route('/organizations/billing.html@organizations/views/Billing/BillingView.js', 'organizations@get_organization');
});

group('ADMIN', () => {

    // System home
    route('/system/home.html@system/views/Home/HomeView.js');

    // Organizations list
    route('/system/organizations/list.html@system/views/OrganizationsList/OrganizationsListView.js', 'organizations@get_organizations', [

        route('/system/organizations/:organizations_uuid/edit.html@system/views/OrganizationsEdit/OrganizationsEditView.js')
    ]);

    // Accounts list
    route('/system/accounts/list.html@system/views/AccountsList/AccountsListView.js', 'accounts@get_accounts', [

            // Accounts add
            route('/system/accounts/add.html@system/views/AccountsAdd/AccountsAddView.js'),

            // Accounts update
            route('/system/accounts/:accounts_uuid/update.html@system/views/AccountsUpdate/AccountsUpdateView.js', 'account@get_account'),

            // Privileges list
            route('/system/accounts/:accounts_uuid/privileges/list.html@system/views/PrivilegesList/PrivilegesListView.js', 'privileges@get_account_privileges', [

                // Privileges add
                route('/system/accounts/:accounts_uuid/privileges/add.html@system/views/PrivilegesAdd/PrivilegesAddView.js')
            ])
        ]
    );

    // Documents list
    route('/system/documents/list.html@system/views/DocumentsList/DocumentsListView.js', 'documents@get_documents');

    // Feedback list
    route('/system/feedback/list.html@system/views/FeedbackList/FeedbackListView.js', 'feedback@get_feedback');
});

// Login
route('/system/login.html@system/views/Login/LoginView.js');

ReactDOM.createRoot(document.getElementById("root")).render(

    // <React.StrictMode>

        <App />

    // </React.StrictMode>
);

ServiceWorker.register();
